<template lang="html">
  <div class="promotion-poster" v-if="newPosters && newPosters.length > 0">
    <swipe :auto="3000" :showIndicators="newPosters.length > 1">
      <swipe-item v-for="(item, index) in newPosters" :key="index">
        <a :href="item.link" @click="clickImage(index)">
          <img v-lazy="$$viewImage(item.image, width, height)" />
        </a>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'mint-ui'

export default {
  props: {
    posters: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: Number,
      default: 750
    },
    height: {
      type: Number,
      default: 375
    },
    trackParams: {
      type: String
    }
  },
  methods: {
    clickImage(index) {
      this.$emit(index)
    }
  },
  computed: {
    newPosters() {
      return this.posters.filter(ele => ele.link !== '' && ele.image !== '')
    }
  },
  components: {
    Swipe,
    SwipeItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.promotion-poster {
  a {
    display: block;
    height: 100%;
  }
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';

.promotion-poster {
  .mint-swipe-indicator.mint-swipe-indicator {
    opacity: 1;
    width: 6px;
    height: 6px;
    background: #fff;
    transition: transform 0.2s;
    border-radius: 50%;
  }
  .mint-swipe-indicator.mint-swipe-indicator.is-active {
    // background: #ff3d81;
    transform: scale(1.5);
  }
}
</style>
